import React from 'react';

import type { RedditPostComponentsProps } from './types';

export function Footer(_props: RedditPostComponentsProps): React.JSX.Element {
	return <div>Reddit Group Post Footer</div>;
}
